import React, { FC } from 'react';
import { Theme, Svg } from 'styled';
import { Color } from 'styled/theme/colors';

type Props = {
  className?: string;
  innerCircleColor?: Color;
  outerCircleColor?: Color;
};

const RoundFillableSelect: FC<Props> = ({
  className = '',
  innerCircleColor = 'white',
  outerCircleColor = 'black',
}) => (
  <Svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    className={className}
    fill="transparent"
  >
    <desc>Round Fillable Select Icon.</desc>
    <circle
      cx="10"
      cy="10"
      r="8.5"
      fill={Theme.colors.white}
      stroke={Theme.colors[outerCircleColor]}
      strokeWidth="3"
    />
    <circle
      r="3.5"
      transform="matrix(-1 0 0 1 10 10)"
      fill={Theme.colors[innerCircleColor]}
      stroke={Theme.colors[innerCircleColor]}
      strokeWidth="3"
    />
  </Svg>
);

export default RoundFillableSelect;
